import { lazy, Loadable } from "src/routes/utils";

// AUTH
export const LoginPage = Loadable(
  lazy(() => import("src/pages/auth/LoginPage"))
);
export const RegisterPage = Loadable(
  lazy(() => import("src/pages/auth/RegisterPage"))
);
export const VerifyCodePage = Loadable(
  lazy(() => import("src/pages/auth/VerifyCodePage"))
);
export const NewPasswordPage = Loadable(
  lazy(() => import("src/pages/auth/NewPasswordPage"))
);
export const ChangePasswordPage = Loadable(
  lazy(() => import("src/pages/auth/ChangePasswordPage"))
);
export const ResetPasswordPage = Loadable(
  lazy(() => import("src/pages/auth/ResetPasswordPage"))
);
export const ForgotPasswordPage = Loadable(
  lazy(() => import("src/pages/auth/ForgotPasswordPage"))
);
export const VerifyResetTokenPage = Loadable(
  lazy(() => import("src/pages/auth/VerifyResetTokenPage"))
);
export const PasswordResetSuccessPage = Loadable(
  lazy(() => import("src/pages/auth/PasswordResetSuccessPage"))
);

// =====SX Dashboard======
export const TeacherListPage = Loadable(
  lazy(() => import("src/pages/teachers/TeacherListPage"))
);
export const TeacherCreatePage = Loadable(
  lazy(() => import("src/pages/teachers/AddTeacherDialog"))
);
export const TeacherDetailsPage = Loadable(
  lazy(() => import("src/pages/teachers/profile/TeacherDetailsPage"))
);
export const AdminListPage = Loadable(
  lazy(() => import("src/pages/admins/AdminListPage"))
);
export const PublicLinkListPage = Loadable(
  lazy(() => import("src/pages/publicLink/PublicLinkListPage"))
);
export const StudentListPage = Loadable(
  lazy(() => import("src/pages/student/StudentListPage"))
);
export const StudentDetailsPage = Loadable(
  lazy(() => import("src/pages/student/StudentDetailsPage"))
);
export const BlueprintListPage = Loadable(
  lazy(() => import("src/pages/blueprint/BlueprintListPage"))
);
export const ProgramListPage = Loadable(
  lazy(() => import("src/pages/course/ProgramListPage"))
);

// DASHBOARD: GENERAL
export const Dashboard = Loadable(lazy(() => import("src/pages/Dashboard")));

// DASHBOARD: REPORT
export const ReportListPage = Loadable(
  lazy(() => import("src/pages/student/Learning/PublicLearningPage"))
);

// User Activity
export const UserActivityListPage = Loadable(
  lazy(() => import("src/pages/userActivity/UserActivityListPage"))
);

export const PublicLearningPage = Loadable(
  lazy(() => import("src/pages/student/Learning/PublicLearningPage"))
);

export const PublicAssessmentPage = Loadable(
  lazy(() => import("src/pages/student/Assessment/PublicAssessmentPage"))
);

export const ReportDetailsPage = Loadable(
  lazy(() => import("src/pages/dashboard/report/ReportDetailsPage"))
);

export const StudentWeeklyReportPage = Loadable(
  lazy(() => import("src/pages/studentWeeklyReport/StudentWeeklyReportPage"))
);

export const ScheduleReportPage = Loadable(
  lazy(() => import("src/pages/dashboard/report/ScheduleReportPage"))
);

export const TeacherReportPage = Loadable(
  lazy(() => import("src/pages/teacherReports/TeacherReportPage"))
);
export const TeacherWorkReportPage = Loadable(
  lazy(() => import("src/pages/teacherReports/TeacherWorkReportPage"))
);

export const SchedulePage = Loadable(
  lazy(() => import("src/pages/schedule/SchedulePage"))
);

// TEST RENDER PAGE BY ROLE
export const PermissionDeniedPage = Loadable(
  lazy(() => import("src/pages/dashboard/PermissionDeniedPage"))
);

// MAIN
export const Page404 = Loadable(lazy(() => import("src/pages/Page404")));
